import axios from 'axios';

// Si usas proxy de Vite (recomendado), no necesitas VITE_API_URL.
const baseURL = import.meta.env.VITE_API_URL || '/api/v1';

const api = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json' },
});

// Interceptor para añadir el token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Interceptor para manejar respuestas y errores
api.interceptors.response.use(
  (response) => response.data, // Devuelve directamente { success, data, message }
  (error) => {
    const esIntentoDeLogin = error.config?.url?.includes('/auth/login');
    if (error.response?.status === 401 && !esIntentoDeLogin) {
      localStorage.removeItem('token');
      if (!window.location.pathname.includes('/public')) {
        window.location.href = '/login';
      }
    }
    const message = error.response?.data?.error || error.message || 'Error de conexión';
    const apiError = new Error(message);
    apiError.status = error.response?.status;
    apiError.details = error.response?.data?.details || null;
    return Promise.reject(apiError);
  }
);

export default api;
